import * as corgi from 'external/dev_april_corgi+/js/corgi';
import {CHANGED} from 'external/dev_april_corgi+/js/emu/events';

import {Input} from './widgets';

interface MenubarProps {
  graphName: string;
  saveState: 'clean' | 'dirty' | 'saving';
}

export function Menubar({graphName, saveState}: MenubarProps) {
  return (
    <div className="bg-neutral-800 drop-shadow flex gap-1 items-center px-2 py-1">
      <MenubarItem label="File" onClick="fileMenuClicked" />
      <MenubarItem label="Add" onClick="addMenuClicked" />
      <MenubarItem label="Tools" onClick="toolsMenuClicked" />
      <div className="w-4" />
      <Input
        className="bg-neutral-700 text-sm"
        value={graphName}
        unboundEvents={{corgi: [[CHANGED, 'rename']]}}
      />
      <div className="flex h-full items-center text-neutral-400 text-sm w-4">
        {saveState === 'dirty' ? '*' : ''}
        {saveState === 'saving' ? '...' : ''}
      </div>
      <div className="grow" />
    </div>
  );
}

function MenubarItem({label, onClick}: {label: string; onClick: string}) {
  return (
    <div
      className="cursor-pointer hover:bg-neutral-700 px-2 py-1 rounded select-none text-sm"
      unboundEvents={{click: onClick}}
    >
      {label}
    </div>
  );
}
